/**
 * Ajoute une méthode de validation de téléphone personnalisée au validateur jQuery
 *
 * @param {function} jQuery - The jQuery object.
 * @returns {void}
 *
 * Pour la Belgique (indicatif +32), REGEX vérifie qu'il y a 7 à 9 chiffres après l'indicatif pour téléphone fixe et mobile.
 * Pour la France (indicatif +33), REGEX vérifie qu'il y a exactement 8 à 9 chiffres après l'indicatif pour téléphone fixe et mobile.
 * Pour le Luxembourg (indicatif +352), REGEX vérifie qu'il y a 6 à 9 chiffres après l'indicatif pour téléphone fixe et mobile.
 */
export const addCustomPhoneValidator = (jQuery) => {
  jQuery.validator.addMethod(
    "customPhone",
    function (value, element) {
      return (
        this.optional(element) || /^((\+|00)32)[1-9]\d{6,8}$|^((\+|00)33)\d{8,9}$|^((\+|00)352)\d{6,8}$/.test(value)
      );
    },
    "Veuillez saisir un numéro valide avec l'indicatif téléphonique de votre pays. Par exemple : +32, +33 ou +352",
  );
};

/**
 * Récupérer l'index actuel de l'étape du formulaire et styliser les boutons de navigations
 *
 * @param {jQuery} pageIndex - The element where the page index will be updated.
 * @param {Object} jQuery - jQuery object.
 * @returns {void}
 */
export const getIndexPaginationForm = (pageIndex, jQuery) => {
  const index = jQuery(".wizard .steps .current").index();
  const isLastStep = jQuery(".wizard>.content>.body").length === index + 1;
  const $prevBtn = jQuery(".actions li:first-of-type a");
  const $nextBtn = jQuery(".actions li:last-of-type a");

  jQuery(".wizard .steps ul").addClass("ux-customScroll");

  pageIndex.empty();
  pageIndex.append("0", index + 1);

  // $(".actions li:first-of-type, .actions li:last-of-type").attr("tabindex", 0);
  $prevBtn.empty().addClass("stepsButton prev");
  $nextBtn.empty().addClass("stepsButton next");

  $prevBtn.append("<span>page précédente</span>");

  if (isLastStep) {
    $nextBtn.addClass("no-arrow");
  } else {
    $nextBtn.append("<span>page suivante</span>").removeClass("no-arrow");
  }
};

/**
 * Personnaliser les messages d'erreur de validation par défaut fournis par le plugin jQuery Validation.
 *
 * @param {Object} jQuery - jQuery object.
 * @return {void}
 */
export function addCustomValidationMessages(jQuery) {
  jQuery.extend(jQuery.validator.messages, {
    required: "ce champs est requis.",
    email: "Veuillez entrer un email valide.",
    remote: "Veuillez corriger ce champ.",
    phone: "Le numéro de téléphone est requis.",
    number: "Veuillez entrer un nombre valide.",
    max: jQuery.validator.format("Veuillez entrer une valeur plus petite ou égale à {0}."),
    min: jQuery.validator.format("Veuillez entrer une valeur plus grande ou égale à {0}."),
    url: "Veuillez entrer une adresse valide.",
    date: "Veuillez entrer une date valide.",
    dateISO: "Veuillez entrer une date valide (ISO).",
    digits: "Veuillez saisir uniquement des chiffres.",
    creditcard: "Veuillez saisir un numéro de carte de crédit valide.",
    equalTo: "Veuillez saisir à nouveau la même valeur.",
    accept: "Veuillez saisir une valeur avec une extension valide.",
    maxlength: jQuery.validator.format("Veuillez ne pas saisir plus de {0} caractères."),
    minlength: jQuery.validator.format("Veuillez saisir au moins {0} caractères."),
    rangelength: jQuery.validator.format("Veuillez saisir une valeur entre {0} et {1} caractères."),
    range: jQuery.validator.format("Veuillez saisir une valeur comprise entre {0} et {1}."),
  });
}

/**
 * Ajouter/retirer la classe "active" sur le label d'un input cible
 *
 * @param {Object} jQuery - jQuery object.
 * @return {void}
 */
const toggleActiveClass = function () {
  const label = jQuery(`label[for='${this.id}']`);

  // verifier seulement si l'input a une valeur non vide
  if (this.value !== "") {
    // jQuery(this).attr("aria-invalid") === "true" ||
    label.addClass("active");
  } else {
    label.removeClass("active");
  }
};

/**
 * Applique la fonction toggleActiveClass à chaque input cible lors de l'événement "change"
 *
 * @param {jQuery} input - Les éléments input (ex : $(".ci-Form-group .ci-Form-input"))
 */
export const toggleActiveClassEachLabel = (input) => {
  input.on("change", function () {
    toggleActiveClass.call(this);
  });
};
